import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import DynamicCalendarWrapper from './DynamicCalendarWrapper';

loadDOMComponent({
	selector: 'react-dynamic-calendar',
	callback: ({ container }: any) => {
		const calendarId = container.getAttribute('calendarId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<DynamicCalendarWrapper calendarId={calendarId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
